import {
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from '@mui/material';

const TableSkeleton = ({ rows = 3, columns = 1 }) => {
    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {[...Array(rows)].map((_, index) => (
                        <TableRow key={index}>
                            {[...Array(columns)].map((_, index) => (
                                <TableCell key={index}>
                                    <Skeleton variant="text" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableSkeleton;
